import { Vue } from 'vue-property-decorator';
import moment from 'moment';
import { GlobalVariables } from '@/libs/core/global';

Vue.filter('partyAddress', (value : any) => {
    if (value) {
        const n: Array<string | null> = [ value.street ?? null, value.city ?? null, value.zip ?? null ];
        return n.filter(x => x != null && x.length > 0).join(", ");
    }
})